import React, { useEffect, useState } from "react";
import { Form, FormGroup, Label, Input, Button, Card, CardBody, CardTitle, Row, Col } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomSelect from "components/Common/custom-select";
import { FiPlusCircle, FiSave } from "react-icons/fi";
import nv6 from "../../../assets/images/brands/b-nav-6.png";
import { fetchEmployeeTabWiseInfo } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import CustomDatePicker from "common/CustomDatePicker";

// select custome style
const SelectcustomStyles = {
  control: (base) => ({
    ...base,
    maxheight: 33.1,
    minHeight: 33.1,
    // overflow: "scroll",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    padding: "0", // Match the padding for both dropdown and clear indicator
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "2px 8px", // Ensure consistent padding for dropdown indicator
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "2px 8px", // Adjust padding for clear indicator to match dropdown
  }),
};

// const statusOptions = [
//   { value: "1", label: "Pending" },
//   { value: "2", label: "Approved" },
//   { value: "3", label: "Rejected" },
// ];

const statusOptions = [
  { value: 0, label: "InActive" },
  { value: 1, label: "Active" },
];

const ExitDetails = ({ empID,isActive }) => {
  const dispatch = useDispatch();
  const {
      employeeExitInfo = [],
      loading,
      error,
      } = useSelector((state) => ({
        employeeExitInfo: empID == 0 ? [] : state.EmployeeDetailsReducer?.employeeTabData?.work_exit || [],
      
      loading: state.employeeReducer?.loading,
      error: state.employeeReducer?.error,
      }));
  const [employeeExitDetails, setEmployeeExitDetails] = useState(employeeExitInfo[0] || {});
  
  useEffect(() => {
    if (employeeExitInfo.length > 0) {
      setEmployeeExitDetails(employeeExitInfo[0]);
    }else {
      setEmployeeExitDetails();
    }
  }, [employeeExitInfo]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
  
    const parts = dateString.split("-");
    if (parts.length !== 3) return "";
  
    return `${parts[2]}-${parts[1]}-${parts[0]}`; 
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      resignedDate: formatDate(employeeExitDetails?.resign_dt),
      noticePeriod: employeeExitDetails?.notice_period ?? "",
      acceptedDate: formatDate(employeeExitDetails?.accept_dt),
      status: employeeExitDetails?.bactive,
      relievedDate: formatDate(employeeExitDetails?.relieve_dt),
    },  
    validationSchema: Yup.object({
      // resignedDate: Yup.date().required("Resigned Date is required"),
      // noticePeriod: Yup.string().required("Notice Period is required"),
      // acceptedDate: Yup.date().required("Accepted Date is required"),
      // status: Yup.string().required("Status is required"),
      // relievedDate: Yup.date().required("Relieved Date is required"),
    }),
    onSubmit: (values) => {
      // console.log("Exit Details Submitted:", values);
      // alert("Exit Details Submitted Successfully!");
      // onSubmit && onSubmit(values);
    },
  });

    useEffect(() => {
        if(isActive){
          dispatch(fetchEmployeeTabWiseInfo(empID,'work_exit'));
        }
    }, [dispatch,isActive]);

  return (
    <Card>
      <div className="card-main-title">
        <h6 className="title">
          <img src={nv6} className="img-fluid w-auto h-auto" alt="img" />
          Exit Details
        </h6>
      </div>
      <CardBody>
        <CardTitle tag="h5" style={{ color: "#0bb2d4", fontWeight: "bold" }}></CardTitle>
        <Form onSubmit={formik.handleSubmit}>
          <Row>
            <Col md={4}>
              <FormGroup>
                <Label>Resigned Date</Label>
                {/* <Input type="date" {...formik.getFieldProps("resignedDate")} disabled /> */}
                <CustomDatePicker
                    value={formik.values.resignedDate}
                    onChange={(date) => formik.setFieldValue("resignedDate", date)}
                    onBlur={() => formik.setFieldTouched("resignedDate", true)}
                    disabled
                  />
                {formik.touched.resignedDate && formik.errors.resignedDate && (
                  <div className="text-danger">{formik.errors.resignedDate}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={4}>
              <FormGroup>
                <Label>Notice Period</Label>
                <Input type="text" {...formik.getFieldProps("noticePeriod")} disabled/>
                {/* <CustomDatePicker
                    value={formik.values.noticePeriod}
                    onChange={(date) => formik.setFieldValue("noticePeriod", date)}
                    onBlur={() => formik.setFieldTouched("noticePeriod", true)}
                    disabled
                  /> */}
                {formik.touched.noticePeriod && formik.errors.noticePeriod && (
                  <div className="text-danger">{formik.errors.noticePeriod}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={4}>
              <FormGroup>
                <Label>Accepted Date</Label>
                {/* <Input type="date" {...formik.getFieldProps("acceptedDate")} disabled/> */}
                <CustomDatePicker
                    value={formik.values.acceptedDate}
                    onChange={(date) => formik.setFieldValue("acceptedDate", date)}
                    onBlur={() => formik.setFieldTouched("acceptedDate", true)}
                    disabled
                  />
                {formik.touched.acceptedDate && formik.errors.acceptedDate && (
                  <div className="text-danger">{formik.errors.acceptedDate}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={4}>
              <FormGroup>
                <Label>Status <span className="text-danger">*</span></Label>
                <CustomSelect
                  styles={SelectcustomStyles}
                  options={statusOptions}
                  name="status"
                  value={statusOptions.find((option) => option.value === formik.values.status) || null}
                  onChange={(selectedOption) => formik.setFieldValue("status", selectedOption?.value)}
                  isDisabled
                />
                {formik.touched.status && formik.errors.status && (
                  <div className="text-danger">{formik.errors.status}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={4}>
              <FormGroup>
                <Label>Relieved Date</Label>
                {/* <Input type="date" {...formik.getFieldProps("relievedDate")} disabled/> */}
                <CustomDatePicker
                    value={formik.values.relievedDate}
                    onChange={(date) => formik.setFieldValue("relievedDate", date)}
                    onBlur={() => formik.setFieldTouched("relievedDate", true)}
                    disabled
                  />
                {formik.touched.relievedDate && formik.errors.relievedDate && (
                  <div className="text-danger">{formik.errors.relievedDate}</div>
                )}
              </FormGroup>
            </Col>
            {/* <Col md={4} className="d-flex justify-content-end align-items-center">
              <Button color="primary" type="submit" >
                <FiSave /> Save & Continue
              </Button>
            </Col> */}
          </Row>
        </Form>
      </CardBody>
    </Card>
  );
};

export default ExitDetails;
